import { useState } from 'react';
import { useTracking } from '@podiumhq/tracking';

import { useTrialsContext } from 'contexts/TrialsContextProvider';
import useChangePage from 'hooks/useChangePage';
import { TRIAL_URL } from 'routes/constants';

import useIsInView from './useIsInView';

const useTrialAccountDetails = () => {
  const changePage = useChangePage();
  const { isInPodiumIframe } = useIsInView();
  const { trackEvent } = useTracking();
  const { accountExists, hasValidLogin, inviteExists } =
    useTrialsContext() || {};

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    setIsSubmitting(true);

    hasValidLogin(true)
      .then((isValidAccountDetails) => {
        trackEvent('trials.accountInfo.nextClicked', {
          valid: isValidAccountDetails,
        });

        setIsSubmitting(false);

        if (isValidAccountDetails && inviteExists) {
          changePage('user-invite-exists');
        }

        if (isValidAccountDetails && !accountExists && !inviteExists) {
          changePage(`${TRIAL_URL}/profile`);
        }
      })
      .catch((error) => {
        trackEvent('trials.accountInfo.error', {
          error: JSON.stringify(error),
        });
        setIsSubmitting(false);
      });
  };

  return {
    handleSubmit,
    isInPodiumIframe,
    isSubmitting,
  };
};

export default useTrialAccountDetails;
